module.exports = __webpack_public_path__ + "img/078dd75.png";